/**
 * DEMO_STORY_OVERRIDES
 *
 * Hardcoded structured content for specific story IDs used in live demos.
 * The StructuredTakeaway component checks this map FIRST — before any API call.
 *
 * Schema per entry:
 *   event_detail:          string (2-3 sentences, max 40 words)
 *   impact.portfolio_companies: string[]
 *   impact.peers:          string[]
 *   impact.geographies:    string[]
 *   magnitude:             { label: string, value: string }[] (exactly 2 items)
 *   topic:                 string (short topic for impact chain header)
 *   primary_company:       string (main portfolio company name)
 *   impact_chain: {
 *     direct: string[] (2 bullet points, max 15 words each)
 *     secondary: string[] (2 bullet points, max 15 words each)
 *     broader: string[] (2 bullet points, max 15 words each)
 *   }
 */

export const DEMO_STORY_OVERRIDES = {
  "76143": {
    event_detail:
      "Accelerating quantum computing progress threatens blockchain cryptography. Aleo's privacy-focused blockchain faces exposure with ECC primitives and ZK systems requiring migration to post-quantum cryptography.",
    impact: {
      portfolio_companies: ["Aleo"],
      peers: ["Aztec Network", "StarkWare", "Zcash"],
      geographies: ["United States", "European Union", "China"],
    },
    magnitude: [
      { label: "R&D INVESTMENT REQUIRED", value: "$10-25M" },
      { label: "NEAR-TERM VALUATION IMPACT", value: "- 15-25%" },
    ],
    topic: "Quantum Computing Threat",
    primary_company: "Aleo",
    impact_chain: {
      direct: [
        "ECC migration requires significant R&D investment for core protocol infrastructure",
        "ZK proving system redesign needed with no drop-in replacement currently available"
      ],
      secondary: [
        "Engineering resources redirected may delay dApp deployment by 6-12 months",
        "Competitive positioning depends on crypto-agility implementation speed versus peers"
      ],
      broader: [
        "Early PQC adoption could position Aleo as leader for regulated verticals",
        "Market uncertainty around quantum timelines may affect investor sentiment and funding"
      ]
    }
  },
};
